/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Program } from '../../models/program';

export interface FindOneProgram$Params {
  programSlug: string;
}

export function findOneProgram(
  http: HttpClient,
  rootUrl: string,
  params: FindOneProgram$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Program>> {
  const rb = new RequestBuilder(rootUrl, findOneProgram.PATH, 'get');
  if (params) {
    rb.path('programSlug', params.programSlug, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Program>;
    })
  );
}

findOneProgram.PATH = '/programs/{programSlug}';
